import React, { useState,useEffect } from 'react'
import './Works.scss'
import {AiFillEye,AiFillGithub} from 'react-icons/ai'
import {animate, easeInOut, motion} from 'framer-motion'
import {urlFor,client} from '../../client'
import {AppWrap,MotionWrap} from '../../wrapper'
const Works = () => {
  const[animateCard , setAnimateCard]=useState({y:0,opacity:1})
  
   const [works,setWorks]=useState([])
   const [filterWork,setFilterWork]=useState([]);

  const[activeFilter,setActiveFilter]=useState('All')
  
  useEffect(()=>{
    const query='*[_type=="works"]'
    client.fetch(query).then((data)=>{
      setWorks(data);
      setFilterWork(data);
    });},[])
  const HandleWorkFilter=(item)=>{
    setActiveFilter(item);
    setAnimateCard([{y:0,opacity:0}])
    setTimeout(()=>{
      setAnimateCard([{y:0,opacity:1}])
      
      if(item==='All'){setFilterWork(works);}else{
  setFilterWork(works.filter((work)=>work.tags.includes(item)))
}

},500)
}
return (
  <>
    <h2 className='head-text'>My Creative <span>  Work </span>
    </h2>
<div className="app__work-filter">
  {['Wordpress','ReactJS','All'].map((item,index)=>(
    <div
    key={index}
    onClick={()=> HandleWorkFilter(item)}
    className={`app__work-filter-item app__flex p-text ${activeFilter===item?'item-active':''}`}
    >{item}</div>
    ))}

</div>
<motion.div
animate={animateCard}
transition={{duration:.5,delayChildren:0.5 }}
className='app__work-portfolio'
>
  {filterWork.map((work,index)=>(
    
    <div className="app__work-item app_flex" key={index}>
      <div className='app__work-img app__flex'>
      
      <img src={urlFor(work.imgUrl)} alt={work.name} />
      <a href={work.codeLink} target='_blank' rel='noreferrer'>  
      
 <motion.div
 whileHover={{opacity:[0,1]}}
 transition={{duration:.25,
ease:'easeInOut', staggerChildren:.5}}
className='app__work-hover app__flex'
>
  <a href={work.codeLink} target='_blank' rel='noreferrer'>
<a href={work.codeLink} target='_blank' rel='noreferrer'>
  <motion.div
  whileInView={{scale:[0,1]}}
  whileHover={{scale:[1,0.9]}}
  transition={{duration:.25}}
  className='app__flex'
  >
  <AiFillEye/>
  </motion.div>
</a>


<a href={work.codeLink} target='_blank' rel='noreferrer'>
  <motion.div
  whileInView={{scale:[0,1]}}
  whileHover={{scale:[1,0.9]}}
  transition={{duration:.25}}
  className='app__flex'
  >
  <AiFillGithub/>
  </motion.div>
</a>
    </a>
 </motion.div>
</a>
      </div>

    <a href={work.codeLink} target='_blank' rel='noreferrer'>
<div className='app__work-content app__flex'>

  <h4 className='bold-text'>

    {work.title}
  
  </h4>
  <p className='p-text' style={{marginTop:10}}>

    {work.description}

    </p>

<div className='app__work-tag app__flex'>

  <p className='p-text'>{work.tags[0]}</p>
</div>

</div>
</a>

    </div>
  
  ))}
</motion.div>
 
 
 </>
  )
}

export default  AppWrap(MotionWrap(Works,'app__works'),'work')
